module.exports = __webpack_public_path__ + "img/智能业务流程b.83e39373.png";